module.exports = __webpack_public_path__ + "static/hotel-general-ecd9adf87d3cdbf6975054a2cc9ff5b1.jpg";